document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('[data-site-header]');
  const toggle = document.querySelector('[data-mobile-nav-toggle]');

  if (header && toggle) {
    toggle.addEventListener('click', () => {
      const isOpen = header.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  const mobileCarouselGeneration = (window.__forseMobileCarouselGeneration || 0) + 1;
  window.__forseMobileCarouselGeneration = mobileCarouselGeneration;

  const previousMobileCarouselController = window.__forseMobileCarouselController;
  if (previousMobileCarouselController) previousMobileCarouselController.destroy();

  const mobileCarouselMedia = window.matchMedia('(max-width: 900px)');
  const mobileCampaignCarousels = [...document.querySelectorAll('.velv-campaign-carousel__viewport')]
    .map((viewport) => {
      const track = viewport.querySelector('.velv-campaign-carousel__track');
      const firstGroup = viewport.querySelector('.velv-campaign-carousel__group');
      const secondGroup = viewport.querySelector('.velv-campaign-carousel__group[aria-hidden="true"]');

      return {
        viewport,
        track,
        firstGroup,
        secondGroup,
        offset: 0,
        isActive: false
      };
    })
    .filter((carousel) => carousel.track && carousel.firstGroup);
  const mobileCarouselLookup = new WeakMap(
    mobileCampaignCarousels.map((carousel) => [carousel.viewport, carousel])
  );
  const mobileCarouselObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const carousel = mobileCarouselLookup.get(entry.target);
            if (carousel) carousel.isActive = entry.isIntersecting;
          });
        },
        { rootMargin: '100% 0px', threshold: 0 }
      )
    : null;
  let mobileCarouselPreviousTime = performance.now();
  let mobileCarouselFrame = 0;
  let mobileCarouselDestroyed = false;

  const setMobileCampaignCarouselMode = () => {
    mobileCarouselPreviousTime = performance.now();

    mobileCampaignCarousels.forEach((carousel) => {
      const { viewport, track, secondGroup } = carousel;
      carousel.offset = 0;
      viewport.scrollLeft = 0;

      if (secondGroup && !secondGroup.isConnected) track.append(secondGroup);

      if (mobileCarouselMedia.matches) {
        viewport.classList.add('is-mobile-controlled');
        track.style.transform = 'translate3d(0, 0, 0)';
      } else {
        viewport.classList.remove('is-mobile-controlled');
        track.style.removeProperty('transform');
      }
    });
  };

  const animateMobileCampaignCarousels = (time) => {
    if (
      mobileCarouselDestroyed ||
      window.__forseMobileCarouselGeneration !== mobileCarouselGeneration
    ) return;

    const elapsed = Math.min(time - mobileCarouselPreviousTime, 64);
    mobileCarouselPreviousTime = time;

    if (mobileCarouselMedia.matches && !document.hidden) {
      mobileCampaignCarousels.forEach((carousel) => {
        if (!carousel.isActive) return;

        const groupWidth = carousel.firstGroup.getBoundingClientRect().width;
        if (!groupWidth) return;

        const desktopDuration =
          parseFloat(getComputedStyle(carousel.track).getPropertyValue('--carousel-speed')) || 42;
        const mobileDuration = desktopDuration * 0.9;
        const distance = (groupWidth * elapsed) / (mobileDuration * 1000);

        carousel.offset = (carousel.offset + distance) % groupWidth;
        carousel.track.style.transform =
          'translate3d(' + -carousel.offset + 'px, 0, 0)';
      });
    }

    mobileCarouselFrame = window.requestAnimationFrame(animateMobileCampaignCarousels);
  };

  if (mobileCampaignCarousels.length) {
    mobileCampaignCarousels.forEach((carousel) => {
      if (mobileCarouselObserver) {
        mobileCarouselObserver.observe(carousel.viewport);
      } else {
        carousel.isActive = true;
      }
    });
    setMobileCampaignCarouselMode();
    if (typeof mobileCarouselMedia.addEventListener === 'function') {
      mobileCarouselMedia.addEventListener('change', setMobileCampaignCarouselMode);
    } else {
      mobileCarouselMedia.addListener(setMobileCampaignCarouselMode);
    }
    mobileCarouselFrame = window.requestAnimationFrame(animateMobileCampaignCarousels);

    window.__forseMobileCarouselController = {
      destroy() {
        mobileCarouselDestroyed = true;
        window.cancelAnimationFrame(mobileCarouselFrame);
        if (mobileCarouselObserver) mobileCarouselObserver.disconnect();
        if (typeof mobileCarouselMedia.removeEventListener === 'function') {
          mobileCarouselMedia.removeEventListener('change', setMobileCampaignCarouselMode);
        } else {
          mobileCarouselMedia.removeListener(setMobileCampaignCarouselMode);
        }
      }
    };
  }

  const revealItems = document.querySelectorAll(
    '.forse-active__intro, .forse-active__product, .forse-manifest__line, .forse-archive__heading, .forse-archive__drop, .vel-products__heading, .vel-product, .vel-universe h2, .vel-archive__heading, .vel-archive__drop, .vel-archive-product, .velv-reveal, .newsletter'
  );

  if ('IntersectionObserver' in window) {
    revealItems.forEach((item) => item.classList.add('is-reveal-ready'));
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.16 }
    );
    revealItems.forEach((item) => observer.observe(item));
  }

  document.querySelectorAll('.velv-hero-patch-reveal').forEach((item) => {
    const patchImages = item.querySelectorAll('.velv-hero-patch-reveal__img--patches');
    const hidePatches = () => {
      patchImages.forEach((image) => image.classList.remove('is-patch-visible'));
    };
    const showPatch = (patchId) => {
      hidePatches();
      const image = item.querySelector(`.velv-hero-patch-reveal__img--${patchId}`);
      if (image) image.classList.add('is-patch-visible');
    };

    item.querySelectorAll('[data-patch-hotspot]').forEach((hotspot) => {
      const patchId = hotspot.dataset.patchHotspot;

      hotspot.addEventListener('pointerenter', () => showPatch(patchId));
      hotspot.addEventListener('pointerleave', hidePatches);
      hotspot.addEventListener('focusin', () => showPatch(patchId));
      hotspot.addEventListener('focusout', hidePatches);
      hotspot.addEventListener(
        'touchstart',
        () => {
          const image = item.querySelector(`.velv-hero-patch-reveal__img--${patchId}`);
          const isVisible = image && image.classList.contains('is-patch-visible');
          hidePatches();
          if (!isVisible && image) image.classList.add('is-patch-visible');
        },
        { passive: true }
      );
    });
  });

  const hidePatchReveal = (container) => {
    if (!container) return;
    container.querySelectorAll('.velv-hero-patch-reveal__img--patches').forEach((image) => {
      image.classList.remove('is-patch-visible');
    });
  };

  const showPatchReveal = (hotspot) => {
    if (!hotspot) return;
    const container = hotspot.closest('.velv-hero-patch-reveal');
    const patchId = hotspot.dataset.patchHotspot;
    if (!container || !patchId) return;
    hidePatchReveal(container);
    const image = container.querySelector(`.velv-hero-patch-reveal__img--${patchId}`);
    if (image) image.classList.add('is-patch-visible');
  };

  document.addEventListener('pointerover', (event) => {
    showPatchReveal(event.target.closest('[data-patch-hotspot]'));
  });

  document.addEventListener('mouseover', (event) => {
    showPatchReveal(event.target.closest('[data-patch-hotspot]'));
  });

  document.addEventListener('click', (event) => {
    showPatchReveal(event.target.closest('[data-patch-hotspot]'));
  });

  document.addEventListener('pointerout', (event) => {
    const hotspot = event.target.closest('[data-patch-hotspot]');
    if (!hotspot) return;
    const container = hotspot.closest('.velv-hero-patch-reveal');
    if (container && event.relatedTarget && container.contains(event.relatedTarget)) return;
    hidePatchReveal(container);
  });

  document.addEventListener('focusin', (event) => {
    showPatchReveal(event.target.closest('[data-patch-hotspot]'));
  });

  document.addEventListener('focusout', (event) => {
    const hotspot = event.target.closest('[data-patch-hotspot]');
    if (hotspot) hidePatchReveal(hotspot.closest('.velv-hero-patch-reveal'));
  });

  const patchUpsell = document.querySelector('[data-patch-upsell]');
  const hoodieForms = document.querySelectorAll('[data-hoodie-form]');
  const archiveQuickAddForms = document.querySelectorAll('[data-archive-quick-add]');
  const archiveConfigurators = document.querySelectorAll('[data-archive-configurator]');
  const upsellCloseButtons = document.querySelectorAll('[data-patch-upsell-close]');
  const upsellForms = document.querySelectorAll('[data-upsell-form]');

  const setButtonState = (button, text, isDisabled) => {
    if (!button) return;
    button.textContent = text;
    button.disabled = isDisabled;
  };

  const refreshCartCount = async () => {
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) return;
      const cart = await response.json();
      document.querySelectorAll('[data-cart-count]').forEach((item) => {
        item.textContent = cart.item_count;
      });
    } catch (error) {
      // Cart count is non-critical; the line item has already been added.
    }
  };

  const openPatchUpsell = (selectedPatchTitle) => {
    if (!patchUpsell) return;
    const normalizedSelection = (selectedPatchTitle || '').trim().toLowerCase();
    const selectedPatchKey = normalizedSelection.includes('origin')
      ? 'origin'
      : normalizedSelection.includes('evolution')
        ? 'evolution'
        : normalizedSelection;
    let visibleCards = 0;

    patchUpsell.querySelectorAll('[data-upsell-card]').forEach((card) => {
      const cardTitle = (card.dataset.patchTitle || '').trim().toLowerCase();
      const cardPatchKey = cardTitle.includes('origin')
        ? 'origin'
        : cardTitle.includes('evolution')
          ? 'evolution'
          : cardTitle;
      const shouldHide = cardPatchKey === selectedPatchKey;
      card.classList.toggle('is-hidden', shouldHide);
      if (!shouldHide) visibleCards += 1;
    });

    patchUpsell.classList.toggle('has-one-upsell', visibleCards === 1);

    const copy = patchUpsell.querySelector('[data-patch-upsell-copy]');
    if (copy && selectedPatchTitle) {
      copy.textContent = `Has elegido ${selectedPatchTitle} gratis con la sudadera. Puedes sumar los otros packs al pedido antes de ir al carrito.`;
    }

    if (visibleCards === 0) {
      window.location.href = '/cart';
      return;
    }

    patchUpsell.classList.add('is-open');
    patchUpsell.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-upsell-open');
  };

  const closePatchUpsell = () => {
    if (!patchUpsell) return;
    patchUpsell.classList.remove('is-open');
    patchUpsell.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-upsell-open');
  };

  const closeArchiveConfigurator = (configurator) => {
    if (!configurator) return;
    const toggle = configurator.querySelector('[data-archive-configurator-toggle]');
    const panel = configurator.querySelector('[data-archive-configurator-panel]');
    if (!toggle || !panel) return;
    toggle.setAttribute('aria-expanded', 'false');
    panel.hidden = true;
  };

  archiveConfigurators.forEach((configurator) => {
    const toggle = configurator.querySelector('[data-archive-configurator-toggle]');
    const panel = configurator.querySelector('[data-archive-configurator-panel]');
    if (!toggle || !panel) return;

    toggle.addEventListener('click', () => {
      const willOpen = panel.hidden;
      archiveConfigurators.forEach((item) => {
        if (item !== configurator) closeArchiveConfigurator(item);
      });
      toggle.setAttribute('aria-expanded', String(willOpen));
      panel.hidden = !willOpen;
      if (willOpen) panel.querySelector('select')?.focus();
    });
  });

  document.addEventListener('click', (event) => {
    archiveConfigurators.forEach((configurator) => {
      if (!configurator.contains(event.target)) closeArchiveConfigurator(configurator);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    archiveConfigurators.forEach(closeArchiveConfigurator);
  });

  hoodieForms.forEach((hoodieForm) => {
    const variantData = hoodieForm.querySelector('[data-hoodie-variants]');
    const variantIdInput = hoodieForm.querySelector('[data-hoodie-variant-id]');
    const packProperty = hoodieForm.querySelector('[data-hoodie-pack-property]');
    const optionInputs = [...hoodieForm.querySelectorAll('[data-hoodie-option]')];
    let variants = [];

    if (variantData) {
      try {
        variants = JSON.parse(variantData.textContent);
      } catch (error) {
        variants = [];
      }
    }

    const updateSelectedVariant = () => {
      if (!variants.length || !variantIdInput) return;
      const selectedOptions = optionInputs.map((input) => input.value);
      const selectedVariant = variants.find((variant) =>
        selectedOptions.every((value, index) => variant.options[index] === value)
      );
      const submitButton = hoodieForm.querySelector('button[type="submit"]');

      if (selectedVariant) {
        variantIdInput.value = selectedVariant.id;
        if (packProperty && selectedOptions[1]) packProperty.value = selectedOptions[1];
        if (submitButton) {
          submitButton.disabled = !selectedVariant.available;
          submitButton.textContent = selectedVariant.available ? 'Añadir sudadera' : 'Agotado';
        }
      }
    };

    optionInputs.forEach((input) => input.addEventListener('change', updateSelectedVariant));
    updateSelectedVariant();

    hoodieForm.addEventListener('submit', async (event) => {
      event.preventDefault();
      const submitButton = hoodieForm.querySelector('button[type="submit"]');
      const selectedPatch = hoodieForm.querySelector('input[name="properties[Pack de parches gratis]"]:checked');
      const selectedPack = hoodieForm.querySelector('[data-hoodie-pack]');
      const selectedPatchTitle = selectedPatch ? selectedPatch.value : selectedPack ? selectedPack.value : '';
      const originalText = submitButton ? submitButton.textContent : '';
      const message = hoodieForm.querySelector('[data-hoodie-message]');

      setButtonState(submitButton, 'Añadiendo...', true);
      if (message) message.textContent = '';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(hoodieForm)
        });

        if (!response.ok) throw new Error('Cart add failed');

        await refreshCartCount();
        setButtonState(submitButton, 'Añadido', true);
        closeArchiveConfigurator(hoodieForm.closest('[data-archive-configurator]'));
        openPatchUpsell(selectedPatchTitle);
        window.setTimeout(() => setButtonState(submitButton, originalText, false), 900);
      } catch (error) {
        setButtonState(submitButton, 'Reintentar', false);
        if (message) message.textContent = 'No se ha podido añadir. Inténtalo de nuevo.';
      }
    });
  });

  archiveQuickAddForms.forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const submitButton = form.querySelector('button[type="submit"]');
      const originalText = submitButton ? submitButton.textContent : '';
      setButtonState(submitButton, 'Añadiendo...', true);

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        if (!response.ok) throw new Error('Cart add failed');
        await refreshCartCount();
        setButtonState(submitButton, 'Añadido', true);
        closeArchiveConfigurator(form.closest('[data-archive-configurator]'));
        window.setTimeout(() => setButtonState(submitButton, originalText, false), 900);
      } catch (error) {
        setButtonState(submitButton, 'Reintentar', false);
      }
    });
  });

  upsellForms.forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const submitButton = form.querySelector('button[type="submit"]');
      const originalText = submitButton ? submitButton.textContent : '';

      setButtonState(submitButton, 'Anadiendo...', true);

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });

        if (!response.ok) throw new Error('Cart add failed');

        await refreshCartCount();
        setButtonState(submitButton, 'Anadido', true);
      } catch (error) {
        setButtonState(submitButton, 'Reintentar', false);
      }
    });
  });

  upsellCloseButtons.forEach((button) => {
    button.addEventListener('click', closePatchUpsell);
  });

  if (patchUpsell) {
    patchUpsell.addEventListener('click', (event) => {
      if (event.target === patchUpsell) closePatchUpsell();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closePatchUpsell();
    });
  }
});
